// types
type CommitmentHoursPeriod = {
  hours?: number;
};

type CommitmentHoursDuty = {
  flags: string[];
  periods?: CommitmentHoursPeriod[];
};

type CommitmentHoursDay = {
  hoursForCalculation?: number;
  duties?: CommitmentHoursDuty[];
};

/**
 * A duty flagged STATUS_BLOCKED contributes nothing, and so does a duty without periods — the
 * original expression leans on `(!blocked && sum) || 0` for both, which also turns a summed 0 back
 * into 0.
 */
const getDutyHours = (duty: CommitmentHoursDuty) =>
  (!duty.flags.includes('STATUS_BLOCKED') &&
    duty.periods?.reduce(
      (periodTotal, period) => periodTotal + (period.hours || 0),
      0
    )) ||
  0;

const getDayHours = (day: CommitmentHoursDay) =>
  day.duties?.reduce((dayTotal, duty) => dayTotal + getDutyHours(duty), 0) || 0;

/**
 * The hours behind the commitment hours counter, for one row over the whole displayed period.
 *
 * The two grids count differently: an open request row carries the hours per day ready made, while
 * an employee row holds them per duty period.
 */
export const getCommitmentHours = ({
  days,
  isOpenRequests = false
}: {
  days?: CommitmentHoursDay[];
  isOpenRequests?: boolean;
}): number => {
  if (isOpenRequests) {
    return (
      days?.reduce((total, day) => total + (day.hoursForCalculation || 0), 0) ||
      0
    );
  }

  return days?.reduce((total, day) => total + getDayHours(day), 0) || 0;
};
